import React, {useMemo} from 'react';
import { connect } from 'react-redux';
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";
import sqftShape from "../../../canvas/core/shapes/sqftShape";
import FeatureThumbnail from "../../../../../visComponents/featureThumbnail";

const SectionImage = (props) => {
  const {shape} = props;
  const {resourceControllerCounter} = props;

  const shapeFeature = useMemo(() => {
    return shape.getFeature();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resourceControllerCounter]);

  const featureName = shapeFeature.getFeatureName();
  console.log("shapeFeature FeatureName", featureName);
  console.log("shapeFeature thumbnailUrl", shapeFeature.dbFeature.thumbnailUrl);
  return (
    <div className="sr__section sr__original-cabinet">
      <div className="sr__section-title">
        <FormattedMessage id="Original Cabinet"/>
      </div>
      <div className="sr__section-image">
        <FeatureThumbnail dbFeatureId={shapeFeature.dbFeature.id} feature={shapeFeature}/>
      </div>
      <div className="sr__section-sides u-pt-05">
        {featureName}
      </div>
      {/*<div className="sr__section-title">*/}
      {/*  <FormattedMessage id="Cabinet Size"/>*/}
      {/*</div>*/}
      {/*<div className="sr__dimensions">*/}
      {/*  <CabinetPreview />*/}
      {/*</div>*/}
    </div>
  );
};

SectionImage.propTypes = {
  shape: PropTypes.instanceOf(sqftShape)
}

const mapStateToProps = (store) => ({
  resourceControllerCounter: store.sqftResourceState.resourceControllerCounter,
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(SectionImage);
